// action
import {
    DELETE_INSTITUTE_TEST_PRICING_MASTER,
    DELETE_INSTITUTE_TEST_PRICING_MASTER_FAIL,
    DELETE_INSTITUTE_TEST_PRICING_MASTER_SUCCESS,
    DELETE_INSTITUTE_TEST_PRICING_MASTER_RESET
} from '../action/deleteInstituteTestPricingMasterAction'
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "",
    message: ""
}

export default function (state = initialState, action) {
    switch (action.type) {
        case DELETE_INSTITUTE_TEST_PRICING_MASTER:
            return {
                ...state,
                apiState: "loading"
            }
        case DELETE_INSTITUTE_TEST_PRICING_MASTER_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case DELETE_INSTITUTE_TEST_PRICING_MASTER_SUCCESS:
            return {
                ...state,
                apiState: "success",
                message: action.response.data.message,
            }
        case DELETE_INSTITUTE_TEST_PRICING_MASTER_RESET:
            return initialState
        default:
            return state
    }
}